import { defineMessages } from 'react-intl';

const messages = defineMessages({
  popularAreaOfStudy: {
    id: 'premium-menu.studies.popularAreaOfStudy',
    defaultMessage: 'Popular Area of Study',
  },
});

export default messages;
